import { AnchorModel, Anchor, HStack, VStack } from '@bpba/ui-components';
import styled from 'styled-components';
import {
  TypographyProps,
  typography,
  ColorProps,
  color,
  BorderProps,
  border,
  system,
  LayoutProps,
  layout,
  FlexboxProps,
  flexbox,
} from 'styled-system';
import { CARROUSEL_RADIUS } from '../../constants/styles';
import { FC } from 'react';

const CONTAINER_WIDTH: (number | null)[] = [319 - 18 * 2, 650 - 40 * 2, null, 764];

type Props = {
  texto1?: string;
  texto2?: string;
  enlace?: AnchorModel;
};

export const Bar: FC<Props> = ({ texto1, texto2, enlace }) => {
  if (!texto1 && !texto2) return <></>;

  const mensaje1Component = <BoldLabel> {texto1} </BoldLabel>;
  const mensaje2Component = <div> {texto2} </div>;
  const separator = <>&nbsp;</>;

  const ariaLabel = `${texto1} ${texto2}`;

  return (
    <Container
      display="flex"
      alignItems="center"
      justifyContent="center"
      tabIndex={-1}
      backgroundColor={['secondary.0', 'secondary.1']}
      responsiveColor={['secondary.1', 'white']}
      borderWidth={['1px', '0px']}
      borderTopWidth="0px"
      borderStyle="solid"
      borderColor={['secondary.0', null, null, 'secondary.1']}
      borderBottomLeftRadius={[null, null, null, CARROUSEL_RADIUS]}
      borderBottomRightRadius={[null, null, null, CARROUSEL_RADIUS]}
      height={[56, 50]}
      fontSize={[15, 16, 17, 18]}
      lineHeight={['19px', '20px', '21px', '22px']}
      letterSpacing={['-0.25px', 'unset']}
    >
      <Anchor
        data={enlace}
        display="flex"
        justifyContent="center"
        width="100%"
        marginX={[32, 64, 72, 48, 104]}
        tabIndex={0}
        aria-label={ariaLabel}
      >
        {/*Desktop y tablet */}
        <HStack display={['none', 'flex']} maxWidth={CONTAINER_WIDTH} justifyContent="center">
          {mensaje1Component}
          {separator}
          {mensaje2Component}
        </HStack>
        {/*Mobile*/}
        <VStack display={['flex', 'none']} width={CONTAINER_WIDTH} alignItems="center">
          {mensaje1Component}
          {mensaje2Component}
        </VStack>
      </Anchor>
    </Container>
  );
};

const BoldLabel = styled.div<TypographyProps>(typography, { fontWeight: 700 });

const responsiveColorFn = system({
  responsiveColor: {
    property: 'color',
    scale: 'colors',
  },
});

type ContainerProps = BorderProps & ColorProps & LayoutProps & TypographyProps & FlexboxProps & { responsiveColor: string[] };
const Container = styled.div<ContainerProps>(border, color, layout, flexbox, typography, responsiveColorFn);
